/* 
 * Export component file to be used on project
*/

import IntegerInput from './IntegerInput.js';
export default IntegerInput;
